<script>

export let id, position, path, textAnchor, fontSize, opacity, text, stroke, x, y;


</script>

<g class={"annotation"+id}

			transform={"translate("+position[0]+","+position[1]+")"}>
		
				<path
				d={path}
				{stroke}
                {opacity}
                fill="none"
				></path>

				{#if Array.isArray(text)}

					{#each text as line, j}

						<text
						{x}
						y={y+j*(fontSize+1)}
						{opacity}
						stroke="none"
						fill={stroke}
						font-size={fontSize+"px"}
						text-anchor={textAnchor}
						>{line}
						</text>

					{/each}

				{:else}

					<text
					{x}
					{y}
					{opacity}
					stroke="none"
					fill={stroke}
					font-size={fontSize+"px"}
					text-anchor={textAnchor}
					>{text}
					</text>

				{/if}
</g>